var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from '@emotion/styled';
import { display } from 'styled-system';
import { FullWidthBoxShadow, Grid, GridItem, } from '../../common/components/Grid';
import { PrimaryNavigation, SecondaryNavigation } from './Navigation';
var NavigationGrid = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), display);
NavigationGrid.defaultProps = {
    display: ['none', null, 'flex'],
};
var TopNavigationBar = function (_a) {
    var __legacy_shop_reboot_max_width = _a.__legacy_shop_reboot_max_width, _b = _a.navigation, _c = _b === void 0 ? {} : _b, _d = _c.primary, primary = _d === void 0 ? [] : _d, _e = _c.secondary, secondary = _e === void 0 ? [] : _e, isContentTree = _c.isContentTree;
    return (React.createElement(React.Fragment, null,
        secondary.length > 0 && (React.createElement(NavigationGrid, { legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width, fullWidthBoxShadow: FullWidthBoxShadow.BOTTOM },
            React.createElement(GridItem, { "data-testid": "top-navigation-secondary" },
                React.createElement(SecondaryNavigation, { items: secondary })))),
        primary.length > 0 && (React.createElement(NavigationGrid, { legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width, fullWidthBoxShadow: FullWidthBoxShadow.BOTTOM },
            React.createElement(GridItem, { "data-testid": "top-navigation-primary" },
                React.createElement(PrimaryNavigation, { isContentTree: isContentTree, items: primary }))))));
};
TopNavigationBar.defaultProps = {
    __legacy_shop_reboot_max_width: true,
};
export default TopNavigationBar;
var templateObject_1;
